import React from 'react';
import { defineMessages } from 'react-intl';

import { bem } from 'helpers/class-name';
import { SMARTSPOT_MODE } from 'constants/logic';
import Message from 'components/Message';
import { RadioButton, RadioGroup } from 'components/HookForm';
import SmartToolsSection from './SmartToolsSection';

import './SmartSpotModel.scss';

const { element } = bem('smart-spot-model');

const messages = defineMessages({
  title: {
    id: 'smart-tools.smart-spot-mode.title',
    defaultMessage: 'Set your SmartSpot model',
  },
  description: {
    id: 'smart-tools.smart-spot-mode.description',
    defaultMessage: 'Choose how SmartSpot releases availability for your schedules.',
  },
  recommended: {
    id: 'smart-tools.smart-spot-mode.recommended',
    defaultMessage: 'Recommended',
  },
  standard: {
    id: 'smart-tools.smart-spot-mode.standard',
    defaultMessage: 'Standard',
  },
  standardInfo: {
    id: 'smart-tools.smart-spot-mode.standard-info',
    defaultMessage: 'Optimizes ClassPass visibility to help fill more classes without disrupting direct bookings.',
  },
  conservative: {
    id: 'smart-tools.smart-spot-mode.conservative',
    defaultMessage: 'Conservative',
  },
  conservativeInfo: {
    id: 'smart-tools.smart-spot-mode.conservative-info',
    defaultMessage: 'Limits class visibility and may result in fewer bookings by ClassPass members.',
  },
});

const SmartSpotModel = () => {
  return (
    <SmartToolsSection title={messages.title} description={messages.description}>
      <RadioGroup name="mode" className={element('content-group')}>
        <RadioButton value={SMARTSPOT_MODE.AGGRESSIVE} className={element('content-model-item')}>
          <div className="messages">
            <div className="item-name">
              <Message message={messages.standard} className="label" />
              <Message message={messages.recommended} className="recommended" />
            </div>
            <Message message={messages.standardInfo} className="info" />
          </div>
        </RadioButton>
        <RadioButton value={SMARTSPOT_MODE.CLASSIC} className={element('content-model-item')}>
          <div className="messages">
            <div className="item-name">
              <Message message={messages.conservative} className="label" />
            </div>
            <Message message={messages.conservativeInfo} className="info" />
          </div>
        </RadioButton>
      </RadioGroup>
    </SmartToolsSection>
  );
};

export default SmartSpotModel;
